import React from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface Props {
  id: string
  label: string
  autoComplete: string
  value: string
  animationIndex: number
  onChange: (value: string) => void
}

const AddressInput: React.FC<Props> = ({
  id,
  label,
  autoComplete,
  value,
  animationIndex,
  onChange,
}) => {
  return (
    <div
      className="pop-in flex flex-col gap-2"
      style={{
        animationDelay: `${animationIndex * 64}ms`,
        animationFillMode: 'both',
      }}
    >
      <Label htmlFor={id}>{label}</Label>

      <Input
        id={id}
        name={id}
        required
        autoComplete={autoComplete}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}

export default AddressInput
